export default __webpack_public_path__ + "static/media/zaman.ab9344f7.jpg";